// Copyright (c) 2017 Deere & Company

import LaborAdditiveSearchBox from '../../../shared/components/pip-search-box';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    searchByDropDown: state.pips.laborAdditive.searchByDropDown,
    searchQueryString: state.pips.laborAdditive.searchQueryString
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborAdditiveSearchBox);



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-main/labor-additive-search-box.js